import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import BrandMark from './BrandMark';
import SiteFooter from './SiteFooter';
import './Login.css';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/auth/reset-password`, {
        token,
        password
      });
      setMessage(response.data.message || 'Пароль обновлён');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сбросить пароль');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-brand">
            <BrandMark size="md" />
          </div>
          <h1 className="login-title">Ссылка недействительна</h1>
          <p className="login-subtitle">
            Запросите новую ссылку для сброса пароля.
          </p>
          <div className="toggle-mode">
            <Link to="/forgot-password" className="toggle-button">
              Запросить ссылку
            </Link>
          </div>
          <SiteFooter className="site-footer--auth" />
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <BrandMark size="md" />
        </div>
        <h1 className="login-title">Новый пароль</h1>
        <p className="login-subtitle">Придумайте новый пароль для входа.</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="password"
              placeholder="Новый пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={4}
              className="field"
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Повторите пароль"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              minLength={4}
              className="field"
              autoComplete="new-password"
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Сохранение...' : 'Сохранить пароль'}
          </button>
        </form>

        <div className="toggle-mode">
          <Link to="/login" className="toggle-button">
            Назад ко входу
          </Link>
        </div>

        <SiteFooter className="site-footer--auth" />
      </div>
    </div>
  );
}

export default ResetPassword;
